import { render, staticRenderFns } from "./SelectTaxiV2.vue?vue&type=template&id=68eedcc8&"
import script from "./SelectTaxiV2.vue?vue&type=script&lang=js&"
export * from "./SelectTaxiV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports